import { Component, forwardRef, input, output, ChangeDetectionStrategy } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { CheckboxOption } from '../../interfaces/checkboxOption';



@Component({
    selector: 'app-checkbox-option-group',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './checkbox-option-group.component.html',
    styleUrls: ['./checkbox-option-group.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => CheckboxOptionGroupComponent),
        multi: true
    }]
})
export class CheckboxOptionGroupComponent implements ControlValueAccessor {
    readonly options = input<CheckboxOption[]>([]);
    readonly editMode = input<boolean>(false);

    readonly valueChange = output<any>();
    
    value: any = null;
    disabled = false;
    
    private onChange: (value: any) => void = () => {};
    private onTouched: () => void = () => {};

    public selectOption(value: any) {
        if (this.disabled || !this.editMode()) return;
        this.value = value;
        this.onChange(value);
        this.onTouched();
        this.valueChange.emit(value);
    }

    public isOptionSelected(option: CheckboxOption): boolean {
        // Direct match
        if (this.value === option.value) {
            return true;
        }
        
        // Check if this option should match undefined
        if (option.matchesUndefined && (this.value === undefined || this.value === null)) {
            return true;
        }
        
        return false;
    }

    public writeValue(value: any): void {
        this.value = value;
    }

    public registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    public registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    public setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }
}